<!--
 * @Author: Tahiti
 * @Date: 2025-12-02 10:00:00
 * @LastEditors: Tahiti
 * @LastEditTime: 2025-12-05 16:42:56
 * @Description: Airwallex 信用卡支付弹窗 - 使用 card-number Element 实现手动输入卡号支付
 * @FilePath: /weryai-web/components/Pay/AirwallexCardModal.vue
-->
<template>
    <div v-if="visible" class="fixed inset-0 z-[3000] flex items-center justify-center bg-black/70"
        @click.self="handleClose">
        <div class="relative flex flex-col md:flex-row gap-[30px] bg-[#22242D] rounded-[20px] p-3 md:p-5 max-md:w-[90vw] min-w-[320px] md:min-w-[500px] max-w-[800px] mx-4 shadow-2xl max-h-[90vh] overflow-y-auto"
            @click.stop>
            <div class="absolute top-4 left-3 md:left-5 flex items-center gap-2 cursor-pointer text-white"
                @click="handleClose">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path
                        d="M14.8298 17.0002C15.0161 16.8128 15.1206 16.5594 15.1206 16.2952C15.1206 16.031 15.0161 15.7776 14.8298 15.5902L11.2898 12.0002L14.8298 8.46019C15.0161 8.27283 15.1206 8.01938 15.1206 7.75519C15.1206 7.49101 15.0161 7.23756 14.8298 7.05019C14.7369 6.95646 14.6262 6.88207 14.5044 6.8313C14.3825 6.78053 14.2518 6.75439 14.1198 6.75439C13.9878 6.75439 13.8571 6.78053 13.7352 6.8313C13.6134 6.88207 13.5028 6.95646 13.4098 7.05019L9.16981 11.2902C9.07608 11.3832 9.00169 11.4938 8.95092 11.6156C8.90015 11.7375 8.87401 11.8682 8.87401 12.0002C8.87401 12.1322 8.90015 12.2629 8.95092 12.3848C9.00169 12.5066 9.07608 12.6172 9.16981 12.7102L13.4098 17.0002C13.5028 17.0939 13.6134 17.1683 13.7352 17.2191C13.8571 17.2699 13.9878 17.296 14.1198 17.296C14.2518 17.296 14.3825 17.2699 14.5044 17.2191C14.6262 17.1683 14.7369 17.0939 14.8298 17.0002Z"
                        fill="white" />
                </svg>
                <span class="text-base font-medium">
                    {{ t('order_modal.change_plan') }}
                </span>
            </div>
            <button @click="handleClose"
                class="absolute top-4 right-3 md:right-5 w-6 h-6 flex items-center justify-center text-white hover:scale-105 hover:rotate-180 transition-all duration-300 z-10">
                <img src="@/assets/images/common/_close.webp" alt="close" class="w-[24px]" />
            </button>
            <!-- 错误提示 -->
            <!-- <div
                v-if="error_message"
                class="p-3 rounded-lg bg-red-500/20 border border-red-500/50"
            >
                <p class="text-sm text-red-400 mb-2">{{ error_message }}</p>
                <button
                    v-if="
                        error_message.includes('reCAPTCHA') ||
                        error_message.includes('网络') ||
                        error_message.includes('连接')
                    "
                    @click="handleRetry"
                    class="text-sm text-red-300 hover:text-red-200 underline"
                >
                    {{ t('pricing.airwallex.retry') || 'Retry' }}
                </button>
            </div> -->

            <!-- :style="{ minHeight: `${add_min_height}px` }" -->
            <div class="flex flex-col gap-[15px] md:w-[430px] mt-[40px] rounded-[10px] p-[10px]"
                :class="[is_show_card_pay ? `bg-white` : 'bg-transparent']">
                <div class="text-text-adad text-[13px]">
                    {{ t('order_modal.short_pay_type') }}
                </div>
                <div class="flex flex-wrap items-center justify-start gap-[10px]">
                    <template v-for="item in pay_type_enums" :key="item">
                        <span v-if="payLogoEnums?.[item]"
                            class="flex items-center gap-2 rounded-[10px] px-4 py-[10px] cursor-pointer transition-all duration-300"
                            :class="[
                                is_show_card_pay
                                    ? 'bg-black  hover:bg-black/80'
                                    : 'bg-[#333643] hover:bg-[#333643]/80',
                            ]" @click="handleSelectPaymentType(item)">
                            <img :src="payLogoEnums?.[item]?.logo" alt="logo" class="w-6 h-6" />
                            <span class="text-base font-medium text-white whitespace-nowrap">{{
                                payLogoEnums?.[item]?.name }}</span>
                        </span>
                    </template>
                </div>
                <div class="w-full my-[25px] flex items-center justify-center gap-2">
                    <span class="w-full h-[1px] bg-gray-300"></span>
                    <span class="text-[13px] text-text-adad whitespace-nowrap">
                        {{ t('order_modal.or') }}</span>
                    <span class="w-full h-[1px] bg-gray-300"></span>
                </div>

                <!-- 加载状态 -->
                <div v-if="loading" class="flex flex-col items-center justify-center py-8 mt-[50px]">
                    <l-dot-spinner v-if="isClient" size="60" speed="0.9"
                        color="var(--el-menu-active-color)"></l-dot-spinner>
                    <p class="text-black/90 text-sm mt-4">
                        {{ t('order_modal.pay_type_loading') }}
                    </p>
                </div>

                <!-- Airwallex Card Number Element 容器 -->
                <!-- 注意：只在加载时隐藏，有错误时仍然显示，允许用户修改输入 -->
                <div v-if="!loading && is_show_card_pay" class="w-full mb-2 bg-[#F4F6FF] p-[10px] rounded-[10px]">
                    <div class="flex gap-[10px] items-center mb-4">
                        <img src="https://static.weryai.com/growth/image/9e5d09a09ac46c1495ff3fb76f3c56ec.webp"
                            alt="checkbox" class="w-4 h-4" />
                        <span class="flex flex-col gap-[1px]">
                            <span class="text-lg font-medium text-black">
                                {{ t('order_modal.credit_card') }}
                            </span>
                            <span class="text-[12px] text-text-adad">{{
                                t('order_modal.card_notice')
                            }}</span>
                        </span>
                    </div>
                    <!-- 卡号输入框 -->
                    <div class="mb-[10px]">
                        <label class="block text-[13px] font-semibold text-black mb-[5px]">
                            {{ t('order_modal.card_number') }}
                        </label>

                        <div id="airwallex-card-number" class="airwallex-element"></div>
                        <div class="text-[#c12424] text-[13px] mt-1">
                            {{ cardNumberErrorMessage }}
                        </div>
                        <img class="w-[221px] h-4 mt-[10px] mb-[10px]"
                            src="https://static.weryai.com/growth/image/ef01a4c961cdd79d92c755d9992049f9.webp"
                            alt="bank" />
                    </div>

                    <!-- 有效期和安全码 -->
                    <div class="grid grid-cols-2 gap-4 mb-4">
                        <div>
                            <label class="block text-[13px] font-semibold text-black mb-[5px]">
                                {{ t('order_modal.expiry_date') }}
                            </label>
                            <div id="airwallex-expiry-date" class="airwallex-element"></div>
                            <div class="text-[#c12424] text-[13px] mt-1">
                                {{ expiryDateErrorMessage }}
                            </div>
                        </div>
                        <div>
                            <label class="block text-[13px] font-semibold text-black mb-[5px]">
                                {{ t('order_modal.cvv') }}
                            </label>
                            <div id="airwallex-cvv" class="airwallex-element"></div>
                            <div class="text-[#c12424] text-[13px] mt-1">
                                {{ cvvErrorMessage }}
                            </div>
                        </div>
                    </div>

                    <!-- 持卡人姓名（普通输入框，Airwallex 不支持 cardholderName Element） -->
                    <div class="mb-[10px]">
                        <label class="block text-[13px] font-semibold text-black mb-2">
                            {{ t('order_modal.cardholder_name') }}
                        </label>
                        <input v-model="cardholderName" type="text" style="color: #000 !important" :placeholder="t('order_modal.cardholder_name_notice')
                            "
                            class="cardholder-name-input w-full text-[13px] border-none px-4 py-3 rounded-lg bg-white text-black placeholder-[#A5ACB8] focus:outline-none focus:border-none transition-all duration-300"
                            @input="handleCardholderNameInput" />
                    </div>
                    <!-- 3D Secure 认证容器 -->
                    <div v-if="show3DS" id="airwallex-3ds-container" class="w-full mb-4"></div>

                    <!-- 支付按钮 -->
                    <!-- 注意：只在加载时隐藏，有错误时仍然显示，允许用户修改后重试 -->
                    <div v-if="!loading" class="flex w-full justify-center mt-4">
                        <button @click="
                            handleSubmitPayment(
                                goods_data?.subscription_type
                                    ? 'air_wallex_subs'
                                    : 'air_wallex'
                            )
                            " :disabled="!canSubmit || isSubmitting"
                            class="flex items-center justify-center gap-2 px-6 py-3 w-full h-[44px] rounded-[10px] font-semibold text-base transition-all duration-300"
                            :class="canSubmit && !isSubmitting
                                ? 'bg-create-btn text-black hover:brightness-110 hover:scale-105'
                                : 'bg-create-btn/40 text-black/70 cursor-not-allowed'
                                ">
                            <el-icon v-if="isSubmitting" class="animate-spin">
                                <Loading />
                            </el-icon>
                            <svg v-else xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"
                                fill="none">
                                <path
                                    d="M13.4579 6.39962H12.7149V4.91364C12.7149 2.86302 11.0507 1.19873 9.00002 1.19873C6.9494 1.19873 5.28511 2.86302 5.28511 4.91364V6.39962H4.54212C3.72113 6.39962 3.05615 7.06459 3.05615 7.88559V15.3154C3.05615 16.1364 3.72113 16.8014 4.54212 16.8014H13.4579C14.2789 16.8014 14.9439 16.1364 14.9439 15.3154V7.88559C14.9439 7.06459 14.2789 6.39962 13.4579 6.39962ZM9.00002 13.0865C8.17902 13.0865 7.51405 12.4215 7.51405 11.6005C7.51405 10.7795 8.17902 10.1145 9.00002 10.1145C9.82102 10.1145 10.486 10.7795 10.486 11.6005C10.486 12.4215 9.82102 13.0865 9.00002 13.0865ZM11.3033 6.39962H6.69678V4.91364C6.69678 3.64315 7.72953 2.6104 9.00002 2.6104C10.2705 2.6104 11.3033 3.64315 11.3033 4.91364V6.39962Z"
                                    fill="currentColor" />
                            </svg>
                            <span>
                                {{
                                    isSubmitting
                                        ? t('order_modal.processing')
                                        : t('order_modal.pay_now')
                                }}
                            </span>
                        </button>
                    </div>
                </div>
            </div>
            <!-- 商品信息 -->
            <div class="md:mt-[50px] md:gap-5 max-md:min-h-[260px] lg:min-w-[300px] mb-5 flex justify-between flex-col">
                <div class="flex flex-col gap-[15px]">
                    <div class="flex flex-col gap-[5px]">
                        <span class="text-[13px] text-text-adad">
                            {{ t('order_modal.account') }}
                        </span>
                        <span class="text-base font-medium text-white">{{
                            userInfo?.nick_name
                        }}</span>
                    </div>
                    <div v-if="goods_data" class="flex flex-col items-start justify-center gap-[5px] mt-[10px]">
                        <span class="text-[13px] text-text-adad">
                            {{ t('order_modal.product_name') }}
                        </span>
                        <span class="text-base font-medium text-white">
                            {{ goods_data?.name || t('pricing.orderGoods') }}
                        </span>
                        <!-- <span class="text-xl font-bold text-[#F5F2F0]">
                        {{ goods_data.price_show }}
                    </span> -->
                    </div>
                </div>
                <div class="flex flex-col items-start justify-center gap-[15px]">
                    <span class="flex justify-start gap-[12px] items-center text-xs text-text-adad">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path
                                d="M14.4001 1.2L8.1001 0H7.9001L1.6001 1.2C1.3001 1.2 1.1001 1.5 1.1001 1.8V9.2C1.1001 10.4 1.5001 11.5 2.2001 12.4C2.8001 13.2 3.5001 13.9 4.5001 14.5C6.1001 15.5 7.7001 16 7.8001 16H8.1001C8.2001 16 9.8001 15.5 11.4001 14.5C12.4001 13.9 13.1001 13.2 13.7001 12.4C14.4001 11.4 14.8001 10.3 14.8001 9.2V1.8C14.9001 1.5 14.7001 1.3 14.4001 1.2ZM13.7001 9.2C13.7001 10.9 12.7001 12.3 10.9001 13.5C10.1001 14 9.2001 14.4 8.1001 14.8H8.0001C4.2001 13.5 2.3001 11.6 2.3001 9.2V2.4C2.3001 2.3 2.3001 2.3 2.4001 2.3L8.0001 1.3H8.1001L13.6001 2.3C13.7001 2.3 13.7001 2.4 13.7001 2.4V9.2Z"
                                fill="#ADADAD" />
                            <path
                                d="M10.9999 5.80003L6.89993 9.00003L4.99993 7.60003C4.69993 7.40003 4.39993 7.40003 4.19993 7.70003C3.99993 7.90003 3.99993 8.30003 4.29993 8.50003L6.49993 10.2C6.59993 10.3 6.69993 10.3 6.79993 10.3C6.99993 10.3 7.09993 10.3 7.19993 10.2L11.6999 6.70003C11.9999 6.50003 11.9999 6.10003 11.7999 5.90003C11.6999 5.60003 11.2999 5.60003 10.9999 5.80003Z"
                                fill="#ADADAD" />
                        </svg>
                        {{ t('order_modal.paymentInformationIsSafe') }}</span>
                    <span class="flex justify-start gap-[12px] items-center text-xs text-text-adad">
                        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
                            <path
                                d="M13.491 12.3857V15.936C13.491 16.1726 13.2437 16.3201 13.0469 16.2007L9.33857 13.9523C9.05583 13.779 8.7449 13.6935 8.43508 13.6935C8.12524 13.6935 7.81431 13.779 7.53157 13.9523L3.82431 16.1997C3.62749 16.319 3.38022 16.1716 3.38022 15.9349V2.65387C3.38022 2.49751 3.4474 2.35463 3.55356 2.25112C3.66516 2.14087 3.82222 2.07337 3.99772 2.07337H12.8724C13.0479 2.07337 13.205 2.14087 13.3187 2.25112C13.4238 2.35463 13.491 2.49751 13.491 2.65387V3.96033C13.491 4.12965 13.6232 4.26691 13.7863 4.26691H14.6398C14.8029 4.26691 14.9351 4.12965 14.9351 3.96033V2.41088C14.9351 1.90799 14.726 1.45237 14.3891 1.12387C14.0576 0.800984 13.6015 0.599609 13.1032 0.599609H3.76695C3.26754 0.599609 2.81254 0.800984 2.48106 1.12387C2.14412 1.45237 1.93506 1.90912 1.93506 2.41088L1.93614 17.9978C1.93614 18.1024 1.96321 18.2092 2.01954 18.3049C2.18639 18.5884 2.54931 18.6806 2.82771 18.5108L8.08841 15.3225C8.19316 15.2585 8.31247 15.2247 8.434 15.2246C8.55315 15.2246 8.6734 15.2572 8.78065 15.3225L13.997 18.4848C14.002 18.4878 14.0069 18.4911 14.0116 18.4944C14.11 18.5632 14.226 18.5998 14.3447 18.5996C14.6707 18.5996 14.9351 18.3307 14.9351 18V12.3857C14.9351 12.2164 14.8029 12.0791 14.6398 12.0791H13.7863C13.6232 12.0791 13.491 12.2164 13.491 12.3857Z"
                                fill="#9B9C9D" />
                            <path
                                d="M13.9236 8.94855L12.475 7.50001L13.9236 6.05145C14.0255 5.94955 14.0255 5.78436 13.9236 5.68246L13.3175 5.07643C13.2157 4.97455 13.0504 4.97452 12.9485 5.07643L11.5 6.52499L10.0514 5.07643C9.94952 4.97452 9.78433 4.97452 9.68243 5.07643L9.07642 5.68244C8.97454 5.78431 8.97452 5.94953 9.07642 6.05143L10.525 7.49999L9.07642 8.94855C8.97454 9.05045 8.97454 9.21564 9.07642 9.31754L9.68245 9.92357C9.78435 10.0255 9.94954 10.0255 10.0514 9.92357L11.5 8.47504L12.9485 9.92357C13.0504 10.0255 13.2156 10.0255 13.3175 9.92357L13.9235 9.31756C14.0255 9.21564 14.0255 9.05045 13.9236 8.94855Z"
                                fill="#9B9C9D" />
                        </svg>
                        {{ t('order_modal.cancelSubscription') }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted, ref, computed, watch, nextTick } from 'vue'
import {
    emitter,
    emitCheckPayResult,
    emitCloseGoodsModal,
} from '~/utils/emitter'
import { useI18n } from '~/composables/useI18n'
import { payOrderApi } from '~/api/common'
import { createPaymentConsentApi } from '~/api/billing'
import { noticeMessagePopup, debounce, isProductionEnv } from '~/utils/common'
import { useUserStore } from '~/stores/user'
import { createElement, init } from '@airwallex/components-sdk'
import { Loading } from '@element-plus/icons-vue'
import {
    emitOrderGoods,
    showLoginModal,
    emitUpgradeOrder,
} from '@/utils/emitter'
import { useAppStore } from '~/stores/app'
import { sendCreatedOrderApi, upgradeSubscriptionApi } from '~/api/billing'

const appStore = useAppStore()
const { t } = useI18n()
const userStore = useUserStore()

const userInfo = computed(() => {
    return userStore.userInfo
})

const payLogoEnums: any = computed(() => {
    return {
        creem_subs_h5: {
            logo: 'https://static.weryai.com/growth/image/9e4a85ca37816fb974a8bd5c88fed7f0.webp',
            name: 'Creem',
            desc: t('pricing.supperMainbank'),
        },
        air_wallex_subs_h5: {
            logo: 'https://static.weryai.com/growth/image/5ffb45ad2ad8321cdd4bf7935383a5d5.svg',
            name: 'Air Wallex',
            desc: t('pricing.globalCreditCard'),
        },
        paypal_subs_h5: {
            logo: 'https://static.weryai.com/growth/image/6c3a9383de3c74e3fce01f9be859d65e.webp',
            name: 'Paypal',
        },
        creem_h5: {
            logo: 'https://static.weryai.com/growth/image/9e4a85ca37816fb974a8bd5c88fed7f0.webp',
            name: 'Creem',
            desc: t('pricing.supperMainbank'),
        },
        air_wallex_h5: {
            logo: 'https://static.weryai.com/growth/image/5ffb45ad2ad8321cdd4bf7935383a5d5.svg',
            name: 'Air Wallex',
            desc: t('pricing.globalCreditCard'),
        },
        paypal_h5: {
            logo: 'https://static.weryai.com/growth/image/6c3a9383de3c74e3fce01f9be859d65e.webp',
            name: 'Paypal',
        },
    }
})

// 组件状态
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const isClient = ref<boolean>(false)
const isSubmitting = ref<boolean>(false)
const error_message = ref<any>('')
const show3DS = ref<boolean>(false)

// 商品数据
const goods_data = ref<any | null>(null)
const pay_type_enums: any = computed(() => {
    return goods_data?.value?.payment_types?.filter((it: any) => !it.includes('paypal_'))
})
const payment_mode = ref<'pay' | 'save'>('pay')
// 是否为升级订阅
const isUpgradeOrder = ref(false)

// Airwallex Elements
let cardNumberElement: any = null
let expiryDateElement: any = null
let cvvElement: any = null

// SDK 初始化状态
let isSDKInitialized = false

// 持卡人姓名（使用普通输入框，因为 Airwallex 不支持 cardholderName Element）
const cardholderName = ref<string>('')

// 表单验证状态
const isCardNumberReady = ref<boolean>(false)
const isExpiryDateReady = ref<boolean>(false)
const isCvvReady = ref<boolean>(false)
const isCardholderNameReady = ref<boolean>(false)
const cardNumberErrorMessage = ref<string>('')
const expiryDateErrorMessage = ref<string>('')
const cvvErrorMessage = ref<string>('')

const add_min_height = computed(() => {
    let height = 540
    if (!is_show_card_pay.value) {
        return height
    }
    if (cardNumberErrorMessage.value) {
        height += 30
    }
    if (expiryDateErrorMessage.value || cvvErrorMessage.value) {
        height += 30
    }

    return height
})

// 是否可以提交
// 注意：持卡人姓名是可选的，不需要验证
const canSubmit = computed(() => {
    const result =
        isCardNumberReady.value &&
        isExpiryDateReady.value &&
        isCvvReady.value &&
        !isSubmitting.value

    // 调试信息（始终输出，方便排查问题）
    console.log('canSubmit check:', {
        cardNumber: isCardNumberReady.value,
        expiryDate: isExpiryDateReady.value,
        cvv: isCvvReady.value,
        isSubmitting: isSubmitting.value,
        result: result,
    })

    return result
})

/**
 * 处理持卡人姓名输入
 */
const handleCardholderNameInput = () => {
    // 持卡人姓名是可选的，但如果有输入则验证
    isCardholderNameReady.value = cardholderName.value.trim().length > 0

    // 当用户开始输入时，清除之前的错误信息（保留网络相关错误）
    if (
        error_message.value &&
        !error_message.value.includes('reCAPTCHA') &&
        !error_message.value.includes('网络') &&
        !error_message.value.includes('连接')
    ) {
        error_message.value = ''
    }
}

// 监听弹窗显示状态，控制 body 滚动
watch(
    () => visible.value,
    newVal => {
        // @ts-ignore
        if (typeof window === 'undefined' || typeof document === 'undefined')
            return

        if (newVal) {
            document.body.style.overflow = 'hidden'
        } else {
            document.body.style.overflow = 'auto'
            isUpgradeOrder.value = false
        }
    }
)

// 是否展示信用卡支付
const is_show_card_pay = computed(() => {
    return true

    return (
        goods_data.value?.payment_types.includes('air_wallex') ||
        goods_data.value?.payment_types.includes('air_wallex_subs')
    )
})

const accountSummary = computed(() => userStore.accountSummary)

/**
 * 处理打开弹窗
 */
const handleOpen = async (payload: {
    goods: any
    mode?: 'pay' | 'save'
    skipCreateOrder?: boolean
    upgrade?: boolean
}) => {
    try {
        // 保存是否为升级订阅的状态
        isUpgradeOrder.value = payload.upgrade || false

        if (!userStore?.isLoggedIn) {
            showLoginModal()
            return
        }

        // 如果是 VIP 订单(CHAT_PLAN)或升级订阅，不进行订阅检查
        // 如果不是 VIP 订单，且用户已有订阅，则提示不能重复订阅
        const isVipOrder = payload.goods?.subscription_type === 'CHAT_PLAN'
        if (
            !isVipOrder &&
            !payload.upgrade &&
            accountSummary.value?.sub_info?.subscription_type &&
            payload.goods?.subscription_type
        ) {
            noticeMessagePopup(
                t('pricing.hasSubscription'),
                t('common.tip'),
                'success',
                3000
            )
            return
        }

        visible.value = true
        goods_data.value = payload.goods
        payment_mode.value = payload.mode || 'pay'
        error_message.value = ''

        // 验证商品信息
        if (!goods_data.value || !goods_data.value.id) {
            error_message.value = t('pricing.airwallex.invalidGoods')
            noticeMessagePopup(
                error_message.value,
                t('common.tip'),
                'error',
                5000
            )
            return
        }

        // 如果不是继续支付场景，才执行创建订单API调用
        if (!payload.skipCreateOrder) {
            sendCreatedOrderApi(goods_data.value.id)
        }

        if (is_show_card_pay.value) {
            // 初始化 Airwallex Elements（先不创建订单，等用户点击支付时再创建）
            await initAirwallexElements()
        }
    } catch (error: any) {
        console.error('打开支付弹窗失败:', error)
        // 处理 reCAPTCHA 相关错误
        if (error.message && error.message.includes('reCAPTCHA')) {
            error_message.value =
                t('pricing.airwallex.recaptchaError') ||
                '无法连接到验证服务，请检查网络连接后重试'
            noticeMessagePopup(
                error_message.value,
                t('common.tip'),
                'error',
                5000
            )
        } else {
            error_message.value =
                error.message || t('pricing.airwallex.initError')

            noticeMessagePopup(
                error_message.value,
                t('common.tip'),
                'error',
                5000
            )
        }
    }
}

/**
 * 重试初始化
 */
const handleRetry = async () => {
    error_message.value = ''
    // 重置 SDK 初始化状态，强制重新初始化
    isSDKInitialized = false
    // 清理之前的 Elements
    cleanupElements()
    // 重新初始化
    try {
        await initAirwallexElements()
    } catch (error: any) {
        console.error('重试初始化失败:', error)
        if (error.message && error.message.includes('reCAPTCHA')) {
            error_message.value =
                t('pricing.airwallex.recaptchaError') ||
                '无法连接到验证服务，请检查网络连接后重试'
            noticeMessagePopup(
                error_message.value,
                t('common.tip'),
                'error',
                5000
            )
        } else {
            error_message.value =
                error.message || t('pricing.airwallex.initError')
            noticeMessagePopup(
                error_message.value,
                t('common.tip'),
                'error',
                5000
            )
        }
    }
}

/**
 * 初始化 Airwallex Elements
 * 注意：Airwallex card-number 方式不需要在初始化时传递 client_secret
 * client_secret 在用户点击支付时通过 confirm 方法传递
 */
const initAirwallexElements = async () => {
    try {
        loading.value = true
        error_message.value = ''

        // 先初始化 Airwallex SDK（必须在创建 Elements 之前）
        // 避免重复初始化
        if (!isSDKInitialized) {
            // 根据实际环境配置 env 参数：'prod'（生产）、'demo'（演示）、'staging'（预发布）、'dev'（开发）
            // 使用 import.meta.env 来区分环境（在 Nuxt 3/Vite 中推荐使用此方式）
            // import.meta.env.PROD 为 true 表示生产环境，false 表示开发环境
            const env: 'prod' | 'demo' | 'staging' | 'dev' =
                isProductionEnv() === 'production' ? 'prod' : 'demo'

            try {
                await init({
                    env: env,
                    theme: 'dark', // 设置主题为深色模式，可选值：'light' | 'dark'
                })
                isSDKInitialized = true
            } catch (initError: any) {
                console.error('Airwallex SDK 初始化失败:', initError)
                // 如果是 reCAPTCHA 相关错误，提供更友好的提示
                if (
                    initError.message &&
                    initError.message.includes('reCAPTCHA')
                ) {
                    throw new Error(
                        t('pricing.airwallex.recaptchaError') ||
                        '无法连接到验证服务，请检查网络连接后重试'
                    )
                }
                throw initError
            }
        }

        // 等待 DOM 容器渲染（loading 为 false 时容器才会显示）
        // 先设置 loading 为 false，让容器渲染
        loading.value = false
        await nextTick()

        // 再次等待，确保 DOM 完全渲染
        await new Promise(resolve => setTimeout(resolve, 100))

        // 检查 DOM 容器是否存在
        const cardNumberContainer = document.getElementById(
            'airwallex-card-number'
        )
        const expiryDateContainer = document.getElementById(
            'airwallex-expiry-date'
        )
        const cvvContainer = document.getElementById('airwallex-cvv')

        if (!cardNumberContainer || !expiryDateContainer || !cvvContainer) {
            throw new Error(t('pricing.airwallex.createElementError'))
        }

        // 创建 Card Number Element（不传递 client_secret）
        // @ts-ignore - Airwallex SDK 类型定义可能不完整
        cardNumberElement = await createElement('cardNumber', {
            style: {
                // @ts-ignore
                base: {
                    backgroundColor: '#fff',
                    color: '#000',
                    fontSize: '16px',
                    '::placeholder': {
                        color: '#A5ACB8',
                        fontSize: '12px',
                    },
                },
            },
            placeholder: '1234 1234 1234 1234',
        })

        // 创建 Expiry Date Element（正确的类型名称是 'expiry'）
        // @ts-ignore - Airwallex SDK 类型定义可能不完整
        expiryDateElement = await createElement('expiry', {
            style: {
                // @ts-ignore
                base: {
                    backgroundColor: '#fff',
                    color: '#000',
                    fontSize: '16px',
                    '::placeholder': {
                        color: '#A5ACB8',
                        fontSize: '12px',
                    },
                },
            },
            placeholder: t('order_modal.expiry_date_placeholder'),
        })

        // 创建 CVV Element（正确的类型名称是 'cvc'）
        // @ts-ignore - Airwallex SDK 类型定义可能不完整
        cvvElement = await createElement('cvc', {
            style: {
                // @ts-ignore
                base: {
                    backgroundColor: '#fff',
                    color: '#000',
                    fontSize: '16px',
                    '::placeholder': {
                        color: '#A5ACB8',
                        fontSize: '12px',
                    },
                },
            },
            placeholder: 'CVC',
        })

        // 注意：Airwallex 不支持 cardholderName Element
        // 持卡人姓名使用普通 HTML input 输入框

        // 挂载元素
        cardNumberElement.mount('airwallex-card-number')
        expiryDateElement.mount('airwallex-expiry-date')
        cvvElement.mount('airwallex-cvv')

        // 监听 ready 事件（元素已准备好，但不表示输入已完成）
        cardNumberElement.on('ready', () => {
            console.log('Card Number Element ready')
            // ready 事件只表示元素已准备好，不设置 isCardNumberReady
            // 实际状态由 change 事件控制
            console.log(cardNumberElement?.domElement)
        })

        expiryDateElement.on('ready', () => {
            console.log('Expiry Date Element ready')
        })

        cvvElement.on('ready', () => {
            console.log('CVV Element ready')
        })

        // 监听 change 事件（如果输入完整则更新状态，提升用户体验）
        cardNumberElement.on('change', (event: any) => {
            // Airwallex SDK 的事件数据在 event.detail 中
            const detail = event.detail || event
            console.log('Card Number change:', {
                complete: detail.complete,
                error: detail.error,
                value: detail.value,
                empty: detail.empty,
            })

            // 当用户开始输入时，清除之前的错误信息（保留网络相关错误）
            if (
                error_message.value &&
                !error_message.value.includes('reCAPTCHA') &&
                !error_message.value.includes('网络') &&
                !error_message.value.includes('连接')
            ) {
                error_message.value = ''
            }

            // 如果输入已经完整且有效，立即更新状态（提升用户体验，按钮可以立即启用）
            const isValid =
                (detail.complete === true || detail.complete === 'complete') &&
                !detail.error &&
                !detail.empty

            if (isValid) {
                isCardNumberReady.value = true
                cardNumberErrorMessage.value = ''
            } else if (detail.empty) {
                // 如果输入为空，重置状态
                isCardNumberReady.value = false
            }
        })

        // 监听 blur 事件（失去焦点时），判断输入内容是否完整
        cardNumberElement.on('blur', (event: any) => {
            const detail = event.detail || event
            console.log('Card Number blur:', {
                complete: detail.complete,
                error: detail.error,
                value: detail.value,
                empty: detail.empty,
                fullEvent: event,
                detail: detail,
            })

            // 在失去焦点时判断输入是否完整且有效
            const isValid =
                (detail.complete === true || detail.complete === 'complete') &&
                !detail.error &&
                !detail.empty

            console.log(
                'Card Number blur isValid:',
                isValid,
                'complete:',
                detail.complete,
                'error:',
                detail.error,
                'empty:',
                detail.empty
            )

            // 设置卡号输入完成状态
            isCardNumberReady.value = isValid

            // 如果有错误，保存错误信息
            if (detail.error) {
                cardNumberErrorMessage.value = detail.error.message || ''
            } else {
                cardNumberErrorMessage.value = ''
            }
        })

        expiryDateElement.on('change', (event: any) => {
            // Airwallex SDK 的事件数据在 event.detail 中
            const detail = event.detail || event
            console.log('Expiry Date change:', {
                complete: detail.complete,
                error: detail.error,
                value: detail.value,
                empty: detail.empty,
            })

            // 当用户开始输入时，清除之前的错误信息（保留网络相关错误）
            if (
                error_message.value &&
                !error_message.value.includes('reCAPTCHA') &&
                !error_message.value.includes('网络') &&
                !error_message.value.includes('连接')
            ) {
                error_message.value = ''
            }

            // 如果输入已经完整且有效，立即更新状态（提升用户体验，按钮可以立即启用）
            const isValid =
                (detail.complete === true || detail.complete === 'complete') &&
                !detail.error &&
                !detail.empty

            if (isValid) {
                isExpiryDateReady.value = true
                expiryDateErrorMessage.value = ''
            } else if (detail.empty) {
                // 如果输入为空，重置状态
                isExpiryDateReady.value = false
            }
        })

        // 监听 blur 事件（失去焦点时），判断输入内容是否完整
        expiryDateElement.on('blur', (event: any) => {
            const detail = event.detail || event
            console.log('Expiry Date blur:', {
                complete: detail.complete,
                error: detail.error,
                value: detail.value,
                empty: detail.empty,
                fullEvent: event,
                detail: detail,
            })

            // 在失去焦点时判断输入是否完整且有效
            const isValid =
                (detail.complete === true || detail.complete === 'complete') &&
                !detail.error &&
                !detail.empty

            console.log(
                'Expiry Date blur isValid:',
                isValid,
                'complete:',
                detail.complete,
                'error:',
                detail.error,
                'empty:',
                detail.empty
            )

            // 设置有效期输入完成状态
            isExpiryDateReady.value = isValid

            // 如果有错误，保存错误信息
            if (detail.error) {
                expiryDateErrorMessage.value = detail.error.message || ''
            } else {
                expiryDateErrorMessage.value = ''
            }
        })

        cvvElement.on('change', (event: any) => {
            // Airwallex SDK 的事件数据在 event.detail 中
            const detail = event.detail || event
            console.log('CVV change:', {
                complete: detail.complete,
                error: detail.error,
                value: detail.value,
                empty: detail.empty,
            })

            // 当用户开始输入时，清除之前的错误信息（保留网络相关错误）
            if (
                error_message.value &&
                !error_message.value.includes('reCAPTCHA') &&
                !error_message.value.includes('网络') &&
                !error_message.value.includes('连接')
            ) {
                error_message.value = ''
            }

            // 如果输入已经完整且有效，立即更新状态（提升用户体验，按钮可以立即启用）
            const isValid =
                (detail.complete === true || detail.complete === 'complete') &&
                !detail.error &&
                !detail.empty

            if (isValid) {
                isCvvReady.value = true
                cvvErrorMessage.value = ''
            } else if (detail.empty) {
                // 如果输入为空，重置状态
                isCvvReady.value = false
            }
        })

        // 监听 blur 事件（失去焦点时），判断输入内容是否完整
        cvvElement.on('blur', (event: any) => {
            const detail = event.detail || event
            console.log('CVV blur:', {
                complete: detail.complete,
                error: detail.error,
                value: detail.value,
                empty: detail.empty,
                fullEvent: event,
                detail: detail,
            })

            // 在失去焦点时判断输入是否完整且有效
            const isValid =
                (detail.complete === true || detail.complete === 'complete') &&
                !detail.error &&
                !detail.empty

            console.log(
                'CVV blur isValid:',
                isValid,
                'complete:',
                detail.complete,
                'error:',
                detail.error,
                'empty:',
                detail.empty
            )

            // 设置 CVV 输入完成状态
            isCvvReady.value = isValid

            // 如果有错误，保存错误信息
            if (detail.error) {
                cvvErrorMessage.value = detail.error.message || ''
            } else {
                cvvErrorMessage.value = ''
            }
        })

        // 监听错误事件
        cardNumberElement.on('error', (error: any) => {
            console.error('Card Number Element Error:', error)
            error_message.value =
                error.message || t('pricing.airwallex.paymentError')
            noticeMessagePopup(
                error_message.value,
                t('common.tip'),
                'error',
                5000
            )
        })

        expiryDateElement.on('error', (error: any) => {
            console.error('Expiry Date Element Error:', error)
            error_message.value =
                error.message || t('pricing.airwallex.paymentError')
            noticeMessagePopup(
                error_message.value,
                t('common.tip'),
                'error',
                5000
            )
        })

        cvvElement.on('error', (error: any) => {
            console.error('CVV Element Error:', error)
            error_message.value =
                error.message || t('pricing.airwallex.paymentError')
            noticeMessagePopup(
                error_message.value,
                t('common.tip'),
                'error',
                5000
            )
        })
    } catch (error: any) {
        console.error('初始化 Airwallex Elements 失败:', error)
        loading.value = false
        error_message.value =
            error.message || t('pricing.airwallex.createElementError')
        // noticeMessagePopup(error_message.value, t('common.tip'), 'error', 5000)
        throw error
    }
}

/**
 * 验证所有输入框状态（在提交前重新验证）
 */
const validateAllInputs = async (): Promise<boolean> => {
    // 重新验证所有输入框
    // 注意：由于 Airwallex Element 没有同步方法获取状态，
    // 我们需要通过检查当前状态和可能的错误来判断

    // 如果任何输入框有错误信息，说明验证失败
    if (
        cardNumberErrorMessage.value ||
        expiryDateErrorMessage.value ||
        cvvErrorMessage.value
    ) {
        return false
    }

    // 检查所有必填字段是否都已准备好
    const allReady =
        isCardNumberReady.value && isExpiryDateReady.value && isCvvReady.value

    return allReady
}

/**
 * 提交支付
 */
const handleSubmitPayment = debounce(async (type: string) => {
    if (!canSubmit.value || isSubmitting.value) return

    // 在提交前重新验证所有输入框
    // 这可以确保即使用户修改了输入但没有触发 blur，也能正确验证
    const isValid = await validateAllInputs()
    if (!isValid) {
        noticeMessagePopup(
            t('order_modal.please_complete_all_fields') || '请完成所有必填字段',
            t('common.tip'),
            'warning',
            3000
        )
        return
    }

    try {
        isSubmitting.value = true
        error_message.value = ''

        // 获取订单的 client_secret（从订单创建响应中获取）
        const orderData = {
            goods_id: goods_data.value.id,
            payment_type:
                type ||
                goods_data.value.payment_types?.[0] ||
                'air_wallex_subs',
            redirect: window.location.href,
        }
        // 埋点：创建支付订单（异步执行，不阻塞请求）
        if (import.meta.client && typeof window !== 'undefined') {
            import('~/utils/log-event-func')
                .then(({ analyticsEvent }) => {
                    analyticsEvent('click_pay', {
                        web_site: window.location.pathname,
                        price: goods_data.value.price,
                        payment_types: orderData.payment_type,
                    })
                })
                .catch(() => {
                    // 静默失败，不影响主流程
                })
        }

        const { status, data, message }: any = isUpgradeOrder.value
            ? await upgradeSubscriptionApi(orderData)
            : await payOrderApi(orderData)
        const jsonData: any = data?.charge ? JSON.parse(data?.charge) : null
        if ([2402, 2403].includes(status)) {
            throw new Error(message || t('pricing.airwallex.paymentError'))
        }

        if (status !== 200 || !jsonData) {
            throw new Error(message || t('pricing.airwallex.paymentError'))
        }

        const clientSecret = jsonData.client_secret
        const customer_id = jsonData.customer_id
        const biz_order_id = data?.order_id

        if (!clientSecret) {
            throw new Error(t('pricing.airwallex.paymentError'))
        }

        // 使用 Airwallex SDK 确认支付
        // 如果有持卡人姓名，将其包含在支付请求中
        const confirmOptions: any = {
            client_secret: clientSecret,
        }

        // 如果用户填写了持卡人姓名，将其添加到支付请求中
        if (cardholderName.value.trim()) {
            confirmOptions.billing = {
                first_name: cardholderName.value.trim(),
            }
        }

        console.log('confirmOptions', confirmOptions)

        // 判断是订阅支付还是一次性支付
        // 如果 payment_type 包含 'subs'，说明是订阅支付，需要使用 createPaymentConsent
        // 否则使用 confirm 进行一次性支付
        const paymentType =
            goods_data.value.payment_types?.[0] || 'air_wallex_h5'
        const isSubscription =
            paymentType.includes('subs') || goods_data.value.subscription_type

        if (import.meta.client) {
            const id = goods_data.value.id
            localStorage.setItem('pay_goods_id', id)
            localStorage.setItem(
                id + '_pay_payment_types',
                goods_data.value.payment_types?.[0]
            )
            localStorage.setItem(
                id + '_pay_price',
                goods_data.value.price.toString()
            )
            localStorage.setItem(id + '_has_send_pay_result', 'false')
        }

        let confirmResult: any = null

        if (isSubscription) {
            // 订阅支付：使用 createPaymentConsent 创建支付同意书
            console.log('使用 createPaymentConsent 创建订阅支付')
            confirmResult = await cardNumberElement.createPaymentConsent({
                ...confirmOptions,
                customer_id: customer_id,
                next_triggered_by: 'merchant',
            })
        } else {
            // 一次性支付：使用 confirm 立即支付
            console.log('使用 confirm 进行一次性支付')
            confirmResult = await cardNumberElement.confirm(confirmOptions)
        }

        console.log('confirmResult', confirmResult)

        if (confirmResult && confirmResult.status === 'SUCCEEDED') {
            // 支付成功
            console.log('支付成功！', {
                status: confirmResult.status,
                paymentIntentId: confirmResult.id,
                merchantOrderId: confirmResult.merchant_order_id,
                metadata: confirmResult.metadata,
            })

            noticeMessagePopup(
                t('pricing.airwallex.success'),
                t('common.tip'),
                'success',
                3000
            )

            // 查询支付结果
            // 优先从 confirmResult 中获取订单ID，如果没有则从 data 中获取
            const bizOrderId =
                confirmResult.metadata?.order_id ||
                confirmResult.merchant_order_id ||
                data.biz_order_id ||
                data.order_id

            if (bizOrderId) {
                emitCheckPayResult({
                    biz_order_id: bizOrderId,
                    price: goods_data.value.price || confirmResult.amount,
                })
            }

            // 关闭弹窗
            handleClose()
            emitCloseGoodsModal()
        } else if (isSubscription && confirmResult?.payment_consent_id) {
            const data_ = {
                consent_id: confirmResult.payment_consent_id,
                order_id: biz_order_id,
            }

            const { status, data, message }: any =
                await createPaymentConsentApi(data_)

            if (biz_order_id) {
                emitCheckPayResult({
                    biz_order_id: biz_order_id,
                    price: goods_data.value.price,
                })
            }
            handleClose()
            emitCloseGoodsModal()
        } else {
            // 处理 3D Secure
            if (confirmResult && confirmResult.requires_action) {
                show3DS.value = true
                await handle3DSecure(confirmResult)
            } else {
                throw new Error(t('pricing.airwallex.paymentError'))
            }
        }
    } catch (error: any) {
        console.error('支付失败:', error)
        error_message.value =
            error.message || t('pricing.airwallex.paymentError')
        noticeMessagePopup(
            error_message.value,
            t('common.tip'),
            'warning',
            5000
        )
    } finally {
        isSubmitting.value = false
    }
}, 200)

/**
 * 处理 3D Secure 认证
 */
const handle3DSecure = async (confirmResult: any) => {
    try {
        // 根据 Airwallex 文档实现 3D Secure 处理
        // 这里需要根据实际的 API 实现
        const threeDSContainer = document.getElementById(
            'airwallex-3ds-container'
        )

        if (threeDSContainer && confirmResult.next_action) {
            // 显示 3D Secure 认证界面
            // 具体实现需要根据 Airwallex SDK 的文档
        }
    } catch (error: any) {
        console.error('3D Secure 处理失败:', error)
        error_message.value =
            error.message || t('pricing.airwallex.confirmError')
        noticeMessagePopup(error_message.value, t('common.tip'), 'error', 5000)
    }
}

/**
 * 处理关闭弹窗
 */
const handleClose = () => {
    appStore.getRecentCreatedOrder()

    visible.value = false
    error_message.value = ''
    show3DS.value = false
    isSubmitting.value = false

    // 重置表单状态
    isCardNumberReady.value = false
    isExpiryDateReady.value = false
    isCvvReady.value = false
    isCardholderNameReady.value = false
    cardholderName.value = ''
    cardNumberErrorMessage.value = ''
    expiryDateErrorMessage.value = ''
    cvvErrorMessage.value = ''

    // 清理 Airwallex Elements
    cleanupElements()
}

/**
 * 清理 Airwallex Elements
 */
const cleanupElements = () => {
    try {
        if (cardNumberElement) {
            cardNumberElement.unmount()
            cardNumberElement = null
        }
        if (expiryDateElement) {
            expiryDateElement.unmount()
            expiryDateElement = null
        }
        if (cvvElement) {
            cvvElement.unmount()
            cvvElement = null
        }
        // 注意：不重置 isSDKInitialized，因为 SDK 初始化是全局的
    } catch (error) {
        console.error('清理 Elements 失败:', error)
    }
}

// 点击其他方式支付
const handleSelectPaymentType = (type: string) => {
    const data_ = {
        ...goods_data.value,
        ...{
            payment_types: [type],
        },
    }

    // 如果是升级订阅，调用 emitUpgradeOrder
    if (isUpgradeOrder.value) {
        emitUpgradeOrder(data_, type)
    } else {
        emitOrderGoods(data_, type)
    }
    handleClose()
}

// 组件挂载
onMounted(async () => {
    if (typeof window !== 'undefined') {
        try {
            const { dotSpinner } = await import('ldrs')
            dotSpinner.register()
            isClient.value = true
        } catch (error) {
            console.error('Failed to load ldrs:', error)
            isClient.value = true
        }
    }

    emitter.on('open-airwallex-pay-modal', handleOpen)
})

// 组件卸载
onUnmounted(() => {
    emitter.off('open-airwallex-pay-modal', handleOpen)

    // 清理资源
    handleClose()
})
</script>

<style scoped lang="less">
/* Airwallex Element 样式 */
:deep(.airwallex-element) {
    min-height: 43px;
    padding: 10px 12px;
    background: #fff;
    border-radius: 6px;
    transition: all 0.3s ease;

    // .css-eo9tsk {
    //     background-color: #1c1e27 !important;
    // }

    &:focus-within {
        border-color: #99f768;
        background: rgba(255, 255, 255, 0.15);
    }

    input {
        color: white;
        background: transparent;
        border: none;
        outline: none;
        width: 100%;

        &::placeholder {
            color: rgba(255, 255, 255, 0.5);
        }
    }
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: scale(0.9);
    }

    to {
        opacity: 1;
        transform: scale(1);
    }
}

.fixed {
    animation: fadeIn 0.3s ease-out;
}

[type='text']:focus {
    outline: none !important;
    box-shadow: none !important;
}

/* 覆盖浏览器自动填充时的背景色 */
.cardholder-name-input:-webkit-autofill,
.cardholder-name-input:-webkit-autofill:hover,
.cardholder-name-input:-webkit-autofill:focus,
.cardholder-name-input:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 30px white inset !important;
    box-shadow: 0 0 0 30px white inset !important;
    -webkit-text-fill-color: #000 !important;
    background-color: white !important;
    background: white !important;
}
</style>
